'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'cookie-consent';

interface CookiePrefs {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
}

export default function ConsentAwareTracking() {
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const readConsent = () => {
      try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
          const parsed = JSON.parse(saved) as CookiePrefs;
          setAnalytics(parsed.analytics === true);
          setMarketing(parsed.marketing === true);
        } else {
          setAnalytics(false);
          setMarketing(false);
        }
      } catch {
        setAnalytics(false);
        setMarketing(false);
      }
    };

    readConsent();

    const handler = () => readConsent();
    window.addEventListener('cookie-consent-changed', handler);
    return () => window.removeEventListener('cookie-consent-changed', handler);
  }, []);

  return (
    <>
      {/* Google Analytics — requires analytics consent */}
      {analytics && (
        <>
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=G-J7N8QDD0GL"
            strategy="afterInteractive"
          />
          <Script id="google-analytics" strategy="afterInteractive">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-J7N8QDD0GL');
            `}
          </Script>
        </>
      )}

      {/* Google Ads — requires marketing consent */}
      {marketing && (
        <Script id="google-ads" strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-11228573619');
          `}
        </Script>
      )}

      {/* Google Ads base gtag.js — only if not already loaded via GA */}
      {marketing && !analytics && (
        <Script
          src="https://www.googletagmanager.com/gtag/js?id=AW-11228573619"
          strategy="afterInteractive"
        />
      )}

      {/* Facebook Pixel — requires marketing consent */}
      {marketing && (
        <>
          <Script id="facebook-pixel" strategy="afterInteractive">
            {`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '3311876642366226');
              fbq('track', 'PageView');
            `}
          </Script>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src="https://www.facebook.com/tr?id=3311876642366226&ev=PageView&noscript=1"
              alt=""
            />
          </noscript>
        </>
      )}
    </>
  );
}
